import useSWR from 'swr'
import {apiRequest} from 'store/Misc/apiRequest'

export default function useRole() {
  const {data: Roles, error, mutate} = useSWR('user-mgmt/roles')
  const roles = Roles?.data
  

  // const addData = (data) => console.log('user-mgmt/roles', data)
  // const addData = (data) => mutate([...data])
  const addData = async (payload) => {
    await apiRequest({
      method: 'post',
      url: 'user-mgmt/roles',
      payload
    })

    mutate('user-mgmt/roles', () => [payload, ...roles], false)
  }
  
  const updateData = (data) => {
    const role = roles.filter(({id}) => +id === data.id)[0]
    roles[roles.indexOf(role)] = data
    mutate(roles)
  }

  const deleteData = (role_id) => {
    const newRoles = roles.filter(({id}) => +id !== +role_id)
    mutate(newRoles)
  }

  console.log('Roles hook data', roles)

  return {
    roles,
    isError: error,
    addData,
    updateData,
    deleteData,
    mutate
  }
}